export default {
  contractActivity: {
    contractActivity: {
      title: ({ plural }) => plural(["Actividad", "Actividades"]),
      type: {
        professional: "Empresa",
        pedagogic: "Formación",
      },
      tabs: {
        description: "Descripción",
        document: "Anexos",
      },
      status: {
        complete: "Completa",
        to_complete: "Por completar",
      },
      context: "Contexto",
      description: "Tareas realizadas",
      difficulties_encountered: "Dificultades & soluciones",
      results_obtained: "Resultados obtenidos",
      analysis_and_learning: "Análisis & aprendizaje",
      tools: "Herramientas & tecnologías",
      skills: "Competencias relacionadas",
      autonomy_complexity: "Autonomía & complejidad",
      missions: "Misiones relacionadas",
      no_activities: "Ninguna actividad está definida en este contrato.",
      no_activities_filtered: "Ninguna actividad coincide con el filtro seleccionado.",
      relatedSkills: {
        launch_analysis: "Iniciar el análisis",
        relaunch_analysis: "Relanzar el análisis",
        badge_default: "Análisis IA de competencias",
        badge_with_date: ({ named }) => `Referencial ${named("code")} — Análisis realizado el ${named("date")}`,
        badge_no_date: ({ named }) => `Referencial ${named("code")}`,
        no_activity_id: "Guarda primero la actividad para acceder a las competencias.",
        no_analysis:
          "Haz clic en « Iniciar el análisis » para identificar las competencias movilizadas en esta actividad.",
        ia_disclaimer:
          "<strong>La IA sugiere competencias, no las valida.</strong><br>Tu maestro de aprendizaje las validará al certificar la actividad.",
        analysing: "Análisis en curso, por favor espere…",
        ai_analysis: "Análisis IA de correspondencia entre la actividad y el bloque de competencias",
        summary_title: "Análisis IA de correspondencia de la actividad con las competencias",
        validated: "Validado",
        to_validate: "Por validar",
        validate_all_proposals: "Validar la relación actividad/competencias",
        add_block_picker_title: "Añadir manualmente bloques de competencias",
        add_block_confirm: "Añadir los bloques seleccionados",
        selected_skills_count: ({ named }) =>
          `${named("count")} competencia${named("count") <= 1 ? "" : "s"} seleccionada${named("count") <= 1 ? "" : "s"}`,
        collapsed_selected_skills_heading: "Competencias seleccionadas",
        skill_status_selected: "Competencia seleccionada",
        skill_status_validated: "Competencia validada",
      },
      annexes: {
        count: ({ named }) => `${named("count")} anexo(s) adjunto(s) a esta actividad`,
        technical_documents: "Documentos técnicos",
        screenshots_photos: "Capturas de pantalla & fotos",
        empty: "Ningún anexo adjunto a esta actividad.",
      },
    },
    import: {
      button: "Importar un informe",
      confirm_title: "Suba su informe de actividad",
      confirm_text:
        "La IA lee su documento, lo divide en actividades distintas y rellena previamente los campos estructurados. Organiza su contenido, no se inventa nada.",
      dropzone_hint: "Solo PDF",
      launch: "Iniciar el análisis",
      validation_notice: "Validará y corregirá cada actividad antes de cualquier registro.",
      loading_title: "Análisis en curso",
      step_reading_title: "Lectura del documento",
      step_reading_subtitle: "Extracción del texto y de la estructura",
      step_sections_title: "División en secciones",
      step_sections_subtitle: "Títulos, rupturas temáticas",
      step_detection_title: "Detección de actividades",
      step_detection_subtitle: "Verbos de acción — lo que el aprendiz realmente hizo",
      step_extraction_title: "Extracción de la información",
      step_extraction_subtitle: "Misiones, periodos, tareas, herramientas, fuentes",
      completed: "Análisis terminado",
      error_title: "El análisis no pudo completarse",
      failed: "El análisis del informe ha fallado. Vuelva a lanzarlo.",
      retry: "Volver a lanzar el análisis",
      result_title: "Validación",
      result_empty: "No se ha podido detectar ninguna actividad en este informe.",
      result_count: ({ plural, named }) =>
        plural([`${named("count")} actividad detectada`, `${named("count")} actividades detectadas`]),
      result_sentence: "Hemos identificado {performed} y {observed}.",
      performed_count: ({ plural, named }) =>
        plural([`${named("count")} actividad realizada`, `${named("count")} actividades realizadas`]),
      observed_count: ({ plural, named }) =>
        plural([`${named("count")} actividad observada`, `${named("count")} actividades observadas`]),
      ai_summary_title: "Lo que ha encontrado la IA",
      review_notice:
        "Compruebe la información extraída de cada actividad. Podrá corregirla y completarla en cualquier momento tras la validación.",
      counter_activities: "Actividades",
      counter_excluded: "Secciones descartadas",
      activities_list: "Actividades detectadas en el informe",
      ai_comment_title: "Comentario de la IA",
      status_to_check: "Por revisar",
      status_validated: "Validada",
      not_specified: "No indicado en el informe",
      to_complete: "Por completar tras la validación",
      level_not_specified: "No indicado",
      no_mission: "Ninguna misión vinculada por el momento",
      validate: "Validar esta actividad",
      validate_label: ({ named }) => `Validar la actividad «${named("name")}»`,
      unvalidate: "Anular la validación de esta actividad",
      unvalidate_label: ({ named }) => `Anular la validación de la actividad «${named("name")}»`,
      announcement_validated: ({ named }) =>
        `Actividad « ${named("name")} » validada. ${named("count")} actividad(es) validada(s).`,
      announcement_unvalidated: ({ named }) =>
        `Actividad « ${named("name")} » no validada. ${named("count")} actividad(es) validada(s).`,
      publish: ({ plural, named }) =>
        plural([`Crear ${named("count")} actividad validada`, `Crear ${named("count")} actividades validadas`]),
      publish_success: ({ plural, named }) =>
        plural([
          `${named("count")} actividad importada desde el informe y añadida al cuaderno`,
          `${named("count")} actividades importadas desde el informe y añadidas al cuaderno`,
        ]),
      badge_ia: "Importada por IA",
    },
  },
};
